import { render, staticRenderFns } from "./EditorHeaderComponent.vue?vue&type=template&id=524397f0&scoped=true&"
import script from "./EditorHeaderComponent.vue?vue&type=script&lang=js&"
export * from "./EditorHeaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524397f0",
  null
  
)

export default component.exports